@if (espace$ | async; as espace) { @if ({ value: view$ | async }; as view) { @switch (view.value) { @case (SidebarView.CREER_OBJET_MAQUETTE)
{ @if ((parentSelectedForAddingChild$ | async)?.parent; as parent) {
<app-creer-objet-maquette
    [isUnderEditeur]="true"
    [parentId]="parent.id"
    (enfantAjoute)="enfantAjouteCallback($event)"
    (annule)="annulerAjoutEnfant()"
    [espace]="espace"
>
</app-creer-objet-maquette>
} @else {
<app-creer-objet-maquette [isUnderEditeur]="true" (annule)="annulerAjoutEnfant()" [espace]="espace"></app-creer-objet-maquette>
} } @case (SidebarView.BIBLIOTHEQUE) {
<app-bibliotheque
    [espaceId]="(racine$ | async)?.espace || (espace$ | async)?.id || (espaceIdInUrl$ | async)"
    [parentPourAjoutEnfant]="(parentSelectedForAddingChild$ | async)?.parent"
    [DNDDisabled]="(racine$ | async) === null"
    (ajouterEnfantSous)="doAjouterEnfant($event)"
></app-bibliotheque>
} @case (SidebarView.EDITER_OBJET_MAQUETTE) { @if (objetMaquetteSelected$ | async; as om) {
<app-editeur-objet-maquette
    [omStructure]="om"
    [contexteId]="contexteIdSelected$ | async"
    [espace]="espace"
    (closeSelectedObjetMaquette)="closeSelectedObjetMaquette()"
></app-editeur-objet-maquette>
} } } } }
